<template>
    <v-select :value="getValue"               
              item-value="code" 
              item-text="text" 
              clearable
              :prepend-icon="getIcon" 
              :dense="getDensity"
              :items="inpt_status_select"
              :label="label"
              v-on:input="updateData"
              v-on:click:clear="onClear()"></v-select>   
</template>

<script>

export default {
    props: {
        value: String,
        field: String,
        label: String,
        function: String,
        dense: {
            type: Boolean,
            default: null,
        },
    },
    data() {
        return {
            inpt_status_select: [
                { code: "Actief", text: "Active" },
                { code: "NietActief", text: "Not Active" },
                { code: "InternOnly", text: "Intern only" }],
        }
    },
    methods: {
        updateData(data) {
            this.$emit('updateData',  {"field": this.field, "value": data});
        },  
        onClear(){
           this.updateData(null); 
        },
        getDescription(arg){
            return arg !== '' ? this.inpt_status_select.find(el => el.code===arg).text : '';
        }
    },
    computed: {    
        getIcon(){
            return typeof this.function === 'undefined' || this.function === null || this.function === '' ? '' : 'mdi-filter-outline';
        },
        getDensity(){
            return typeof this.dense === 'undefined' || this.dense === null ? true : this.dense;
        },
        getValue(){
            return typeof this.value === 'undefined' || this.value === null ? null : this.value;
        }                         
    }
}
  
</script>
